// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: what the assistant is doing right now. The server pushes a short
// gerund ("reading your mail") as each tool starts, so a long wait says what it
// is waiting on instead of "thinking" for thirty seconds. Labels expire on
// their own: if the run dies without clearing, the indicator falls back to
// plain thinking rather than lying about live work.
//
// It also says whether a turn is running at all. The server repeats that every
// few seconds while it works; it drives the Stop button, keeps the indicator up
// while a streamed reply is still growing, and holds back read-aloud until the
// reply is final. Missed heartbeats clear it, so a crashed run never leaves a
// Stop button behind.

import {makeAutoObservable} from 'mobx';

const STALE_AFTER_MS = 25_000;
const RUNNING_STALE_AFTER_MS = 20_000;

class AssistantActivityStore {
	private label: string | null = null;
	private at = 0;
	running = false;
	private runningTimer: ReturnType<typeof setTimeout> | null = null;

	constructor() {
		makeAutoObservable<AssistantActivityStore, 'runningTimer'>(this, {runningTimer: false});
	}

	set(label: string | null): void {
		this.label = label?.trim() ? label.trim().slice(0, 80) : null;
		this.at = this.label ? Date.now() : 0;
	}

	setRunning(running: boolean): void {
		this.running = running;
		if (this.runningTimer) clearTimeout(this.runningTimer);
		this.runningTimer = running ? setTimeout(() => this.setRunning(false), RUNNING_STALE_AFTER_MS) : null;
		if (!running) this.set(null);
	}

	current(now: number = Date.now()): string | null {
		if (!this.label) return null;
		return now - this.at < STALE_AFTER_MS ? this.label : null;
	}
}

export default new AssistantActivityStore();
